export const en = {
  'reports.dataset.appointments': 'Sessions',
  'reports.grouping.appointmentType': 'Appointment type',
  'reports.measure.sessions': 'Sessions',
  'reports.measure.completed': 'Completed',
  'reports.measure.noShow': 'No-shows',
  'reports.measure.cancelled': 'Cancelled',
  'reports.measure.showRate': 'Show rate',
  'reports.builtIn.sessionsByTrainer': 'Sessions by trainer',
};

export const ka: Record<keyof typeof en, string> = {
  'reports.dataset.appointments': 'სესიები',
  'reports.grouping.appointmentType': 'ჩანიშვნის ტიპი',
  'reports.measure.sessions': 'სესიები',
  'reports.measure.completed': 'ჩატარებული',
  'reports.measure.noShow': 'არ გამოცხადდა',
  'reports.measure.cancelled': 'გაუქმებული',
  'reports.measure.showRate': 'გამოცხადების მაჩვენებელი',
  'reports.builtIn.sessionsByTrainer': 'სესიები ტრენერების მიხედვით',
};
